import { Route } from "@angular/router";
import { DynamicCsvReportComponent } from "@shared/components/dynamic-csv-report/dynamic-csv-report.component";
import { GenerateReportComponent } from "@shared/components/generate-report/generate-report.component";
import { ProductComponent } from "@shared/components/product/product.component";
import { initialDataResolver } from "app/app.resolvers";
import { AuthGuard } from "app/core/auth/guards/auth.guard";
import { NoAuthGuard } from "app/core/auth/guards/noAuth.guard";
import { LayoutComponent } from "app/layout/layout.component";
import { PublicDigilockerCallbackComponent } from "./public-digilocker-callback/public-digilocker-callback.component";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

  {
    path: "public-digilocker-callback",
    component: PublicDigilockerCallbackComponent,
  },
  // Redirect empty path to '/example'
  { path: "", pathMatch: "full", redirectTo: "adaptive-ui-flow/list" },

  // Redirect signed-in user to the '/example'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: "signed-in-redirect", pathMatch: "full", redirectTo: "adaptive-ui-flow/list" },

  // Auth routes for guests
  {
    path: "",
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      { path: "confirmation-required", loadChildren: () => import("app/modules/auth/confirmation-required/confirmation-required.routes") },
      { path: "forgot-password", loadChildren: () => import("app/modules/auth/forgot-password/forgot-password.routes") },
      { path: "sign-in", loadChildren: () => import("app/modules/auth/sign-in/sign-in.routes") },
      { path: "sign-up", loadChildren: () => import("app/modules/auth/sign-up/sign-up.routes") },
    ],
  },

  // Auth routes for authenticated users
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      { path: "sign-out", loadChildren: () => import("app/modules/auth/sign-out/sign-out.routes") },
      { path: "unlock-session", loadChildren: () => import("app/modules/auth/unlock-session/unlock-session.routes") },
    ],
  },

  // Landing routes
  {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [{ path: "home", loadChildren: () => import("app/modules/landing/home/home.routes") },
    { path: "reset-password", loadChildren: () => import("app/modules/auth/reset-password/reset-password.routes") }
    ],
  },

  // Admin routes
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [{ path: "example", loadChildren: () => import("app/modules/admin/example/example.routes") }],
  },

  //Master routes
  {
    path: "masters",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/masters/masters.module").then((m) => m.MastersModule),
  },

  //Loan Applications
  {
    path: "applications",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/loan-applications/loan-applications.module").then((m) => m.LoanApplicationsModule),
  },

  //Task Tray
  {
    path: "task-tray",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/task-tray/task-tray.module").then((m) => m.TaskTrayModule),
  },

  //Adaptive UI Flow
  {
    path: "adaptive-ui-flow",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/adaptive-ui-flow/adaptive-ui-flow.module").then((m) => m.AdaptiveUiFlowModule),
  },

  //Loans
  {
    path: "loans/list",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/loans/loans.module").then((m) => m.LoansModule),
  },
  // {
  //   path: "adaptive-ui-flow/extended",
  //   canMatch: [AuthGuard],
  //   component: LayoutComponent,
  //   resolve: {
  //     initialData: initialDataResolver,
  //   },
  //   loadChildren: () => import("app/modules/mobile-loan/mobile-loan.module").then((m) => m.MobileLoanModule),
  // },
  {
    path: "adaptive-ui-flow/extended",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    loadChildren: () => import("app/modules/adaptive-ui-flow/adaptive-ui-flow.module").then((m) => m.AdaptiveUiFlowModule),
  },
  {
    path: "product",
    component: ProductComponent,
  },
  //Report
  {
    path: "report",
    canMatch: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      { path: "", component: GenerateReportComponent },
      { path: "dynamic-csv", component: DynamicCsvReportComponent },
    ],
  },
];
